import type { Button as ButtonSchema } from '../../../amplienceTypes/partials/exported/button-schema';
import type { ReactElement } from 'react';

import styled from 'styled-components';

import { AmplienceCmsLink } from '~/components/shared/core/link/AmplienceCmsLink';

const S = {
  Link: styled(AmplienceCmsLink)``,
};

export const Button = ({ url, target, text, ariaLabel }: ButtonSchema): ReactElement => (
  <S.Link
    href={url ?? ''}
    className="contentBlock-body-link js-contentBlock-body-link"
    target={target}
    aria-label={ariaLabel}
  >
    <span className="gstar-icon icon-link contentBlock-body-link-icon" />
    <span className="contentBlock-body-link-label">{text}</span>
  </S.Link>
);
